// extracted by mini-css-extract-plugin
module.exports = {"carouselBanner":"CarouselBanner-Jtails_carouselBanner_3JepW","dingBeautySlickArrowHeight":"CarouselBanner-Jtails_dingBeautySlickArrowHeight_1qp_7"};